
	import Vue from 'vue';
	import {Component, Emit, Prop, Watch} from 'vue-property-decorator';
	import SkinAutocomplete from "@/components/skin/SkinAutocomplete.vue";
	import SkinAvatar from "@/components/skin/SkinAvatar.vue";
	import {ISkin} from "@/models/ISkin";
	import ItemAutocomplete from "@/components/item/ItemAutocomplete.vue";

	@Component({
		components: {ItemAutocomplete, SkinAvatar, SkinAutocomplete}
	})
	export default class SkinSetSteamIdDialog extends Vue {

		@Prop({type: Boolean, default: false})
		public open!: boolean;

		@Prop({type: Object, required: true})
		public skin!: ISkin;

		private loading: boolean = false;
		private steamId: string | null = null;

		private reset(): void {
			this.steamId = this.skin.steam_id;
		}

		private trySave(): void {
			this.loading = true;
			this.$store.dispatch('skin/setSteamId', {id: this.skin.id, steamId: this.steamId})
				.then(() => this.save(this.steamId))
				.finally(() => this.loading = false);
		}

		@Watch('skin.steam_id', {immediate: true})
		private onSkinSteamIdChanged(): void {
			this.reset();
		}

		@Watch('open')
		private onOpenChanged(value: boolean): void {
			if (!value) this.reset();
		}

		@Emit('cancel')
		public cancel(): void {
			//do nothing
		}

		@Emit('save')
		public save(steamId: string | null): string | null {
			return steamId;
		}

	}
